import { omit, pick } from "lodash";
import { dateTimeFormat } from "src/utils/constants";
import {
    defaultAccessibility,
    defaultParsedAddress,
    defaultPlace,
} from "src/utils/defaultData";
import { SignupFormData } from "./types";
import moment from "moment";

export function getInitialValues(isNavigator = false, email = "") {
    return {
        email,
        firstName: "",
        lastName: "",
        password: "",
        birthdate: isNavigator ? "" : new Date(),
        confirmPassword: "",
        defaultProgramMembershipID: "",
        validationCode: "",
        accessibility: defaultAccessibility,
        home: defaultPlace,
        address: defaultParsedAddress,
    };
}

export function formatParaplanAccount(values: SignupFormData) {
    return {
        ...pick(values, ["email", "phone", "password"]),
        accessibility: pick(values.accessibility, [
            "hasPCA",
            "usesWheelchair",
            "wheelChairType",
        ]),
        name: `${values.firstName} ${values.lastName}`,
        birthdateEpoch: moment(values.birthdate).unix(),
        defaultProgramMembershipID: "",
        home: {
            ...omit(values.address, [
                "description",
                "latitude",
                "longitude",
                "street",
            ]),
            lat: values?.address?.latitude || 0,
            lng: values?.address?.longitude || 0,
        },
    };
}

export function formatNavigatorAccount(values: SignupFormData, agency: string) {
    const birthdate = values.birthdate
        ? moment(values.birthdate).format(dateTimeFormat)
        : undefined;
    return {
        ...pick(values, ["email", "phone", "password"]),
        userId: agency,
        name: `${values.firstName} ${values.lastName}`,
        birthdate,
        validationCode: values.validationCode?.trim() || "",
        accessibility: JSON.stringify(values.accessibility),
        address: JSON.stringify(values.address),
    };
}
